// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_banner_bold = /** @type {(inputs: {}) => string} */ () => {
	return `official partner`
};

const el_banner_bold = /** @type {(inputs: {}) => string} */ () => {
	return `επίσημος συνεργάτης`
};

const ru_banner_bold = /** @type {(inputs: {}) => string} */ () => {
	return `партнёр`
};

const he_banner_bold = /** @type {(inputs: {}) => string} */ () => {
	return `הרשמי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const banner_bold = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.banner_bold(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("banner_bold", locale)
	if (locale === "en") return en_banner_bold(inputs)
	if (locale === "el") return el_banner_bold(inputs)
	if (locale === "ru") return ru_banner_bold(inputs)
	if (locale === "he") return he_banner_bold(inputs)
	return "banner_bold"
};